import { AxiosResponse } from 'axios';
import { useContext } from 'react';

import AppContext from '@/contexts/appContext';
import { DeleteCacheKeyResult, KeyInspect, ScanPage } from '@/types/cacheConsole';
import ajax from '@/utils/ajax';

const BASE = '/api/dugout/cache_console';

export const cacheConsoleRepository = {
  async scan({
    host,
    pattern,
    cursor,
    count
  }: {
    host: string;
    pattern?: string;
    cursor?: number;
    count?: number;
  }): Promise<ScanPage> {
    const response = await ajax.get({
      url: `${host}${BASE}/scan/`,
      params: { pattern, cursor, count }
    });
    return response.data;
  },

  async knownKeys({ host }: { host: string }): Promise<string[]> {
    const response = await ajax.get({ url: `${host}${BASE}/known_keys/` });
    return response.data;
  },

  async inspect({ host, key }: { host: string; key: string }): Promise<KeyInspect> {
    const response = await ajax.get({
      url: `${host}${BASE}/inspect/`,
      params: { key }
    });
    return response.data;
  },

  async deleteKey({ host, key }: { host: string; key: string }): Promise<DeleteCacheKeyResult> {
    const response = await ajax.post<{ key: string }, AxiosResponse<DeleteCacheKeyResult>>({
      url: `${host}${BASE}/delete_key/`,
      data: { key }
    });
    return response.data;
  }
};

const CacheConsoleRepository = () => {
  const { host } = useContext(AppContext);

  return {
    scan: (pattern?: string, cursor?: number, count?: number): Promise<ScanPage> =>
      cacheConsoleRepository.scan({ host, pattern, cursor, count }),
    knownKeys: (): Promise<string[]> => cacheConsoleRepository.knownKeys({ host }),
    inspect: (key: string): Promise<KeyInspect> => cacheConsoleRepository.inspect({ host, key }),
    deleteKey: (key: string): Promise<DeleteCacheKeyResult> =>
      cacheConsoleRepository.deleteKey({ host, key })
  };
};

export default CacheConsoleRepository;
